export const clubObjectConstructor = ({ badges, imageUrl, title }) => {
	if (!title)
		return {
			applications: [],
			title: "",
			badges: [],
			id: "",
			imageUrl: "",
			members: [],
			moderators: [],
			verified: "",
		};
	return {
		applications: [],
		title,
		badges,
		id: "",
		imageUrl,
		members: [],
		verified: false,
	};
};

export const userObjectConstructor = ({ id, role, settings: { notifs } }) => {
	if (!id)
		return {
			id: "",
			role: "student",
			settings: {
				notifs: "all",
			},
		};
	return {
		id,
		role,
		settings: {
			notifs,
		},
	};
};

export const eventObjectConstructor = ({ title, type, text }) => ({
	title,
	type,
	text,
});
